import { render, staticRenderFns } from "./CollectionSearch.vue?vue&type=template&id=1129eff2&"
import script from "./CollectionSearch.vue?vue&type=script&lang=js&"
export * from "./CollectionSearch.vue?vue&type=script&lang=js&"
import style0 from "./CollectionSearch.vue?vue&type=style&index=0&id=1129eff2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports